enum StatusType {
  Initial = 'Initial',
  Active = 'Active',
  Complete = 'Complete',
  Closed = 'Closed',
}

export default StatusType;
